export const Step3Data = {
    jockeysArr: [
        'ZPurton',
        'VincentHo',
        'BritneyWong',
        'APouchin',
        'JMcDonald',
        'BThompson',
        'AAtzeni',
        'HBentley',
        'HBowman',
        'KTeetan',
        'LHewitson',
        'MChadwick',
        'DerekLeung',
        'ABadel',
        'LFerraris',
        'AngusChung',
        'JerryChau',
        'MFPoon',
        'AHamelin',
        'MLYeung',
        'KHChan',
        'HTMo',
        'ECWWong',
        'BAvdulla',
        'KDeMelo',
    ],
    trainersArr: [
        'KWLui',
        'DEustace',
        'JSize',
        'FCLor',
        'PFYiu',
        'CSShum',
        'ASCruz',
        'CFownes',
        'KLMan',
        'PCNg',
        'DJHall',
        'DJWhyte',
        'DAHayes',
        'JRichards',
        'TPYung',
        'WYSo',
        'KHTing',
        'CHYip',
        'CWChang',
        'YSTsui',
        'MNewnham',
        'WKMo',
    ],
    horsesArr: [
        'RomanticWarrior_E486',
        'GoldenSixty_C238',
        'LaCityBlanche_G371',
        'Divano_J142',
        'TheWinnabe_J251',
        'KaYingRising_J062',
        'Mugen_H338',
        'Bottomuptogether_J316',
        'CallMeGlorious_H410',
        'CopartnerPrance_H408',
        'FullCredit_J185',
        'GloryElite_H311',
        'HowDeepIsYourLove_H093',
        'InvincibleSage_H301',
        'KingMiles_J158',
        'MagicControl_J333',
        'MassiveSovereign_J208',
        'Mickley_K082',
        'MyWish_J256',
        'PackingHermod_J277',
        'PatchOfTheta_H485',
        'RacingBlizzard_H368',
        'RomanticThor_K012',
        'Rubylot_H412',
        'StunningPeach_J301',
        'ChillChibi_H109',
        'Ensued_H452',
        'Fallon_H219',
        'GalaxyPatch_H399',
        'HappyTogether_G446',
        'HeleneFeeling_H215',
        'TajDragon_H164',
        'LuckySweynesse_G180',
        'DancingCode_G365',
        'Encountered_G236',
        'CaliforniaSpangle_E314',
        'BeautyEternal_H008',
        'VoyageBubble_E436',
        'StraightArron_G435',
        'VictorTheWinner_G404',
        'RedLion_H115',
        'SuperSunnySing_G319',
        'HeliosExpress_H302',
    ],
};
